import { Container, Flex, Image, Link, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";
import { useEffect, useState } from "react";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const ContactLink = ({ children, icon, href }) => {
    return (
        <Link fontSize="md" mb={2} href={href}>
            <Stack direction="row">
                <Image boxSize="20px" objectFit="cover" src={icon} alt={children} loading="lazy" />
                <Text>{children}</Text>
            </Stack>
        </Link>
    );
};

const Contacto = () => {
    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    return (
        <>
            <Header />
            <Head>
                <title>Thank You Page | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/" />
                <link rel="alternate" href="https://grupoguia.mx/" hrefLang="es-mx" />
            </Head>
            <Container
                maxW="8xl"
                {...(screenSize.winWidth <= 768 && { paddingInline: "0" })}
                paddingTop="8rem"
                paddingBottom="6rem"
                mx="auto"
            >
                <Flex justifyContent="center" flexDirection="column" alignItems="center">
                    <Image
                        src="https://media.grupoguia.mx/assets/home-page/icons/icon-check-typ.svg"
                        width="186"
                        height="186"
                        alt="icon"
                    />
                    <Text fontSize="2xl" fontWeight="700">
                        ¡Gracias!
                    </Text>
                    <Text marginTop="0.5rem" marginBottom="1rem" fontSize="md">
                        ¡Llámanos y contáctate con un asesor!
                    </Text>
                    <ContactLink
                        href="tel:+5213336426564"
                        icon="https://media.grupoguia.mx/assets/home-page/icons/llamada-telefonica.webp"
                    >
                        (33) 3642 6564
                    </ContactLink>
                    <ContactLink
                        href="mailto:contacto@grupoguia.mx"
                        icon="https://media.grupoguia.mx/assets/home-page/icons/correo-electronico.webp"
                    >
                        contacto@grupoguia.mx
                    </ContactLink>
                </Flex>
            </Container>
            <Footer visible={true} esGuiaRent={false} />
        </>
    );
};

export default Contacto;
